export const isHigoAccount = (clabe: string): boolean =>
  '6461802366' === clabe?.replace(' ', '').slice(0, 10);
